<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <div>
    <router-view />
  </div>
</template>
<script>
// import liff from '@line/liff'

export default {
  data () {
    return {
      profile: null,
      isLoggedIn: false
    }
  },
  async created () {
  },
  async mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #ffffff;

    &.router-link-exact-active {
      color: #ffffff;
    }
  }
}
.warning {
  background-color: yellow;
  padding: 20px;
  text-align: center;
  font-weight: bold;
}
</style>
